import { createSlice } from '@reduxjs/toolkit';
import { type User } from '@store/api/types';

interface AuthState {
  user?: User;
  isAuthenticated: boolean;
  isLoading: boolean;
}

const initialState: AuthState = { isAuthenticated: false, isLoading: true };

const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    setAuth: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.isLoading = false;
    },

    removeAuth: (state) => {
      state.isAuthenticated = false;
      state.user = undefined;
      state.isLoading = false;
    },

    setLoading: (state) => {
      state.isLoading = true;
    },
  },
});

export const { setAuth, removeAuth } = authSlice.actions;
export default authSlice.reducer;
